import React from "react";
import { Row, Col, Card, Button } from "react-bootstrap";
import _authIcon from "../../../componets/json/authIcon";
import { VscClose } from "react-icons/vsc";
class _renderAddress extends React.Component {
  render() {
    const { e, idx, Bs, _icon } = this.props;
    return (
      <Row className="mb-2">
        <Col>
          <Card bg="uni">
            <Row className="mt-1 mb-1 ms-1 me-1">
              <Col xs={3}>
                <Row>
                  <strong>
                    {e.desc}{" "}
                    {e.ico != "" ? (
                      <small className="text-muted">(IČO:{e.ico})</small>
                    ) : (
                      ""
                    )}
                  </strong>
                </Row>
                <Row>
                  <small>{e.country.label}</small>
                </Row>
              </Col>
              <Col
                xs={5}
                className="d-flex justify-content-start align-items-center"
              >
                <strong>{e.CntctName}</strong>
              </Col>
              <Col xs={3}>
                <Row>
                  <small className="c-black">
                    {typeof e.city == "object" ? e.city.label : e.city}
                  </small>
                </Row>
                <Row>
                  <small className="c-black">
                    {typeof e.street == "object" ? e.street.label : e.street}
                    &nbsp;
                    {typeof e.houseno == "object"
                      ? e.houseno.label.split("/")[0]
                      : e.houseno}
                  </small>
                </Row>
              </Col>
              <Col
                xs={1}
                className="d-flex justify-content-end align-items-center"
              >
                <Button
                  variant="light"
                  size="sm"
                  data-tip="Odstranit"
                  onClick={this.props.remove}
                >
                    <VscClose />
                </Button>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    );
  }
}

export default _renderAddress;
